var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDownload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 4C14.8052 4 15.0526 4.24742 15.0526 4.55263V16.4816L19.6355 11.8987C19.8513 11.6829 20.2012 11.6829 20.417 11.8987C20.6328 12.1145 20.6328 12.4644 20.417 12.6802L14.8907 18.2065C14.6749 18.4223 14.325 18.4223 14.1092 18.2065L8.5829 12.6802C8.36708 12.4644 8.36708 12.1145 8.5829 11.8987C8.79871 11.6829 9.14862 11.6829 9.36443 11.8987L13.9473 16.4816V4.55263C13.9473 4.24742 14.1947 4 14.5 4ZM4.55263 17.2632C4.85784 17.2632 5.10526 17.5106 5.10526 17.8158V22.2369C5.10526 22.6766 5.27993 23.0982 5.59084 23.4092C5.90176 23.7201 6.32345 23.8947 6.76315 23.8947H22.2368C22.6765 23.8947 23.0982 23.7201 23.4091 23.4092C23.72 23.0982 23.8947 22.6766 23.8947 22.2369V17.8158C23.8947 17.5106 24.1421 17.2632 24.4473 17.2632C24.7525 17.2632 24.9999 17.5106 24.9999 17.8158V22.2369C24.9999 22.9697 24.7088 23.6725 24.1906 24.1907C23.6724 24.7089 22.9696 25 22.2368 25H6.76315C6.03031 25 5.3275 24.7089 4.80931 24.1907C4.29112 23.6725 4 22.9697 4 22.2369V17.8158C4 17.5106 4.24742 17.2632 4.55263 17.2632Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download.6567b870.svg";
export { ForwardRef as ReactComponent };